import React, { useEffect, useState } from "react";
import "../styles/redeem.css";
import InvestmentHeaderBox1 from "../components/InvestmentHeaderBox1";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SelectDropDown from "../components/SelectDropDown";
import { Formik, useFormik } from "formik";
import "../styles/profile.css";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { stpScheme, stpShow, stpStore } from "../actions/holdingAction";
import { getLocalStorageUserData } from "../utils/userData";
import { currentDate } from "../utils/DateFormate";
import PopupModel from "../components/PopupModel";
import successlogo from "../images/popup/success-popup.svg";
import cancel from "../images/popup/alert-image.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import calendarImage from "../images/calendar_month.svg";
import { toast } from "react-toastify";
import { useRef } from "react";

const STP = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [stpAlloed, setStpNotAllwoed] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false); // Manage popup visibility
  const userData = getLocalStorageUserData();
  const { stpShows, stpStores, stpSchemes, loading, error } = useSelector(
    (state) => state.holdings
  );
  const dataOfStp = location?.state?.props;
  console.log("dataOfStp", dataOfStp);
  const closeModal = () => {
    setIsPopupVisible(false);
  };

  useEffect(() => {
    const payload = {
      id: userData?.id,
      product_id: dataOfStp?.scheme_code,
      folio_no: dataOfStp?.folioNumber,
    };
    dispatch(stpShow(payload)).then((res) => {
      console.log("resss", res);
      if (res?.status == false) {
        setStpNotAllwoed(res?.message);
      }
    });
  }, []);

  const targetScemaOption = [
    {
      label: "Growth Option",
      value: "Z",
    },
    {
      label: "Dividend Payout",
      value: "X",
    },
    {
      label: "Dividend Reinvest",
      value: "Y",
    },
  ];

  const actionPopup = () => {
    navigate("/portfolio");
  };

  const datePickerRef = useRef(null);
  const formik = useFormik({
    initialValues: {
      client_code: stpShows?.data?.client_code,
      from_scheme_code: dataOfStp?.scheme_code,
      to_scheme_code: "",
      buy_sell_type: "ADDITIONAL",
      transaction_mode: "D",
      folio_no: stpShows?.data?.folio_no?.toString(),
      internal_ref_number: "",
      start_date: "",
      frequency_type: "",
      no_of_transfers: "",
      to_date: "",
      installment_amount: Number(
        (dataOfStp?.current_value || "0").replace(/,/g, "")
      ).toFixed(2),
      installment_units: Number(dataOfStp?.units).toFixed(2),
      first_order_today: "N",
      sub_broker_code: "",
      euin_declaration: "N",
      euin_number: "",
      remarks: "",
      sub_broker_arn: "",

      // amc_product_id: stpShows?.data?.product?.amc_product_id || 0,
      // target_scheme_reinvest: "",
      // all_scheme: null,
      // payout_scheme: null,
      // // reinvest_scheme: "Y",
      // product_code: stpShows?.data?.product?.product_code,
      // product_id: stpShows?.data?.product?.id,
      // productlimit_id: stpShows?.data?.productlimit?.id,
      // isin: stpShows?.data?.product?.isin,
      // amount:
      //   parseInt(stpShows?.data?.currentAmount?.replace(/,/g, "")).toString() ||
      //   "0",
      // current_value: stpShows?.data?.currentAmount,
      // current_units: stpShows?.data?.availableUnits,
      // target_scheme: "",
      // to_scheme_code: "",
      // start_date: "",
      // frequency_type: "",
      // no_of_transfers: "",
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      installment_amount: Yup.string()
        .matches(/^\d+(\.\d+)?$/, "Amount must be a valid number") // Regex to allow only numbers or float values
        .required("Amount is required")
        .typeError("Amount must be a number"),
      // target_scheme: Yup.string()
      //   .notOneOf(["Select"], "Target scheme is required")
      //   .required("Target scheme is required"),
      to_scheme_code: Yup.string()
        .notOneOf(["Select"], "Source scheme is required")
        .required("Source scheme is required"),
      start_date: Yup.string()
        .notOneOf(["Select"], "Day is required")
        .required("Day is required"),
      frequency_type: Yup.string()
        .notOneOf(["Select"], "Frequency is required")
        .required("Frequency is required"),
      no_of_transfers: Yup.number()
        .notOneOf(["Select"], "No. of Installation is required")
        .typeError("No. of Installations must be a number")
        .required("No. of Installations is required")
        .min(1, "No. of Installations must be at least 1"),
    }),
    onSubmit: (values) => {
      dispatch(stpStore(values)).then((response) => {
        if (response) {
          console.log("response", response);
          if (response?.status == true) {
            navigate(
              `/orders?order=${
                response?.orderid ? response?.orderid : response?.order
              }`
            );
          } else {
            setIsPopupVisible(true);
          }
        } else {
          setIsPopupVisible(true);
        }
      });
    },
  });

  const cancelBack = () => {
    formik.resetForm();
    navigate("/portfolio");
  };
  return (
    <div className="container-fluid page_background ">
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box">
          <h5 className="mb-4 main-heading-title">
            <Link className="back_icon" to="/portfolio">
              <FontAwesomeIcon icon={faAngleLeft} className="color me-3" />
            </Link>
            STP
          </h5>
          <InvestmentHeaderBox1 props={dataOfStp} />
          <div className="card redeam_bottom_card ">
            <div className="card-body p-0">
              {stpAlloed !== "" && <p style={{ color: "red" }}>{stpAlloed}</p>}
              <div className="row align-items-center r_inner_section">
                <div className="col-md-auto col-sm-auto my-1">
                  <h6 className="text-muted r_inner_title mb-0">
                    Amount:
                    <span className="fw-bold ms-2">
                      ₹
                      {Number(
                        (dataOfStp?.current_value || "0").replace(/,/g, "")
                      ).toFixed(2)}
                    </span>
                  </h6>
                </div>
                <div className="col-md-auto col-sm-auto px-lg-3 px-0">
                  <span className="divider"></span>
                </div>
                <div className="col-md-auto col-sm-auto my-1">
                  <h6 className="text-muted r_inner_title mb-0">
                    Available units:
                    <span className="fw-bold ms-2 ">
                      {Number(dataOfStp?.units).toFixed(2)}
                    </span>
                  </h6>
                </div>
                <div className="col-md-auto col-sm-auto px-lg-3 px-0">
                  <span className="divider"></span>
                </div>
                <div className="col-md-auto col-sm-auto my-1">
                  <h6 className="text-muted r_inner_title mb-0">
                    NAV as on {currentDate()}:
                    <span className="fw-bold ms-2 text_success">
                      ₹{Number(stpShows?.data?.product_nav || 0).toFixed(2)}
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="card redeam_bottom_card">
              <div className="row form_body justify-content-center">
                <div className="col-xl-7 col-lg-10 col-md-10 my-2">
                  <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label
                        htmlFor="installment_amount"
                        className="form-label"
                      >
                        Amount <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <input
                        type="text"
                        name="installment_amount"
                        id="installment_amount"
                        className="form-control"
                        placeholder="₹"
                        value={formik.values.installment_amount}
                        onChange={formik.handleChange}
                      />
                      {formik.errors.installment_amount &&
                        formik.touched.installment_amount && (
                          <div className="text-danger">
                            {formik.errors.installment_amount}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Target Scheme input */}
                  {/* <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="target_scheme" className="form-label">
                        Target Scheme Option{" "}
                        <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <SelectDropDown
                        name="target_scheme"
                        id="target_scheme"
                        value={formik.values.target_scheme}
                        changeFunction={(value) => {
                          formik?.setFieldValue("target_scheme", value);
                          formik?.setFieldValue("to_scheme_code", "");
                          formik?.setFieldValue("start_date", "");
                          formik?.setFieldValue("frequency_type", "");
                          formik?.setFieldValue("no_of_transfers", "");
                        }}
                        options={targetScemaOption}
                      />
                      {formik.errors.target_scheme &&
                        formik.touched.target_scheme && (
                          <div className="text-danger">
                            {formik.errors.target_scheme}
                          </div>
                        )}
                    </div>
                  </div> */}

                  {/* Source Scheme input */}
                  <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="to_scheme_code" className="form-label">
                        Target Scheme <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <SelectDropDown
                        name="to_scheme_code"
                        id="to_scheme_code"
                        value={formik?.values?.to_scheme_code}
                        changeFunction={(value) => {
                          formik?.setFieldValue("to_scheme_code", value);
                          formik?.setFieldValue("start_date", "");
                          formik?.setFieldValue("frequency_type", "");
                          formik?.setFieldValue("no_of_transfers", "");
                          // const payload = {
                          //   target_amc_product_id: value,
                          //   Source_amc_product_id: value,
                          // };
                          // dispatch(stpScheme(payload));
                        }}
                        options={stpShows?.data?.target_products
                          ?.map((target_product) => {
                            const truncateLabel = (text, maxLength = 60) => {
                              if (!text) return "";
                              return text.length > maxLength
                                ? text.substring(0, maxLength) + "..."
                                : text;
                            };

                            return [
                              {
                                value: target_product.scheme_code,
                                label: truncateLabel(
                                  target_product.scheme_name,
                                  60
                                ), // Label is the product name
                              },
                              {
                                value: target_product.scheme_code,
                                label: `Minimum Amount For STP: ${target_product.new_purchase_min_amount}`, // Show the minimum amount message
                                isDisabled: true, // Disable this option
                              },
                            ];
                          })
                          .flat()}
                        // disabled={
                        //   formik.values.target_scheme != "" &&
                        //   formik.values.target_scheme != "Select"
                        //     ? (option) => option.isDisabled
                        //     : true
                        // }
                      />
                      {formik.errors.to_scheme_code &&
                        formik.touched.to_scheme_code && (
                          <div className="text-danger">
                            {formik.errors.to_scheme_code}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Frequency input */}
                  <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="frequency_type" className="form-label">
                        Frequency <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <SelectDropDown
                        name="frequency_type"
                        id="frequency_type"
                        value={formik?.values?.frequency_type}
                        changeFunction={(value) => {
                          formik?.setFieldValue("frequency_type", value);
                          formik?.setFieldValue("no_of_transfers", "");
                          formik?.setFieldValue("start_date", "");
                        }}
                        options={
                          stpShows?.data?.frequencies
                            ? stpShows?.data?.frequencies?.map((feq) => ({
                                value: feq,
                                label: feq,
                              }))
                            : []
                        }
                        // disabled={
                        //   formik?.values?.start_date != "" &&
                        //   formik?.values?.start_date != "Select"
                        //     ? false
                        //     : true
                        // }
                      />
                      {formik.errors.frequency_type &&
                        formik.touched.frequency_type && (
                          <div className="text-danger">
                            {formik.errors.frequency_type}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Date of Installment input */}
                  <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="start_date" className="form-label">
                        Start Date <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7 position-relative">
                      {/* <SelectDropDown
                        name="start_date"
                        id="start_date"
                        value={formik?.values?.start_date}
                        changeFunction={(value) => {
                          formik?.setFieldValue("start_date", value);
                          formik?.setFieldValue("no_of_transfers", "");
                        }}
                        options={ stpShows?.data?.stpDates?.find((item) => item.astp_status === formik?.values?.frequency_type)?.sip_dates_array?.map((stp_date) => ({
                          value: stp_date,
                          label: stp_date,
                        }))}
                        disabled={
                          formik?.values?.frequency_type != "" &&
                          formik.values.frequency_type != "Select"
                            ? false
                            : true
                        }
                      /> */}
                      <DatePicker
                        ref={datePickerRef}
                        className="w-100"
                        selected={
                          formik?.values?.start_date &&
                          moment(
                            formik?.values?.start_date,
                            "DD/MM/YYYY",
                            true
                          ).isValid()
                            ? moment(
                                formik?.values?.start_date,
                                "DD/MM/YYYY"
                              ).toDate()
                            : null
                        }
                        onChange={(date) => {
                          if (!date || !moment(date).isValid()) return;
                          const formattedDate =
                            moment(date).format("DD/MM/YYYY");
                          formik?.setFieldValue("start_date", formattedDate);
                        }}
                        filterDate={(date) => {
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);

                          const selectedDate = new Date(date);
                          selectedDate.setHours(0, 0, 0, 0);

                          const day = selectedDate.getDate();

                          return (
                            selectedDate >= today &&
                            stpShows?.data?.stpDates
                              ?.find(
                                (item) =>
                                  item.astp_status ===
                                  formik?.values?.frequency_type
                              )
                              ?.sip_dates_array?.map(Number)
                              .includes(day)
                          );
                        }}
                        disabled={
                          formik?.values?.frequency_type !== "" &&
                          formik?.values?.frequency_type !== "Select"
                            ? false
                            : true
                        }
                        dateFormat="dd-MM-yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        customInput={
                          <input className="form-control" readOnly />
                        }
                      />

                      {/* ✅ Calendar icon to open DatePicker */}
                      <img
                        src={calendarImage}
                        alt="Calendar Icon"
                        className="position-absolute imgcal"
                        style={{ cursor: "pointer" }}
                        onClick={() => datePickerRef.current?.setOpen(true)}
                      />
                      {/* <img
                        src={calendarImage}
                        alt="Calendar Icon"
                        className="position-absolute imgcal"
                      ></img> */}
                      {formik.errors.start_date &&
                        formik.touched.start_date && (
                          <div className="text-danger">
                            {formik.errors.start_date}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* Tenure input */}
                  <div className="row align-items-center mb-3">
                    <div className="col-lg-5 col-md-6 col-sm-5">
                      <label htmlFor="no_of_transfers" className="form-label">
                        No. of Installations{" "}
                        <span className="red-color">*</span>
                      </label>
                    </div>
                    <div className="col-lg-7 col-md-6 col-sm-7">
                      <input
                       type="number"
                       className="form-control"
                       placeholder="No. of Installations"
                        name="no_of_transfers"
                        id="no_of_transfers"
                        value={formik?.values?.no_of_transfers}
                        onChange={formik.handleChange}
                        // options={stpShows?.data?.stpDates
                        //   ?.find(
                        //     (item) =>
                        //       item.astp_status ===
                        //       formik?.values?.frequency_type
                        //   )
                        //   ?.tenure?.map((no_of_transfers) => ({
                        //     value: no_of_transfers,
                        //     label: no_of_transfers,
                        //   }))}
                        disabled={
                          formik?.values?.frequency_type != "" &&
                          formik?.values?.frequency_type != "Select"
                            ? false
                            : true
                        }
                      />

                      {formik.errors.no_of_transfers &&
                        formik.touched.no_of_transfers && (
                          <div className="text-danger">
                            {formik.errors.no_of_transfers}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer form_card ">
              <div className="">
                <div className="d-flex justify-content-between gap-2">
                  <button
                    type="button"
                    onClick={cancelBack}
                    className="form_button "
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={
                      parseFloat(
                        dataOfStp?.current_value?.replace(/,/g, "")
                      ) < parseFloat(formik?.values?.amount)
                        ? true
                        : false
                    }
                    className="form_button next_btn"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        {isPopupVisible && stpStores?.status != true && (
          <PopupModel
            id="alertModel"
            title="Lorem Ipsum"
            content={stpStores?.message}
            image={cancel}
            actionPopup={actionPopup}
            closeModal={closeModal}
            btnColor={"btn-success"}
          />
        )}
      </div>
    </div>
  );
};

export default STP;
